export default "__VITE_ASSET__5i6QMjal__"